const replaceUrl = (url: string): void => {
    window.location.replace(url);
};

export const pushUrl = (url: string): void => {
    window.location.assign(url);
};

const shouldRedirect = (): boolean => !window?.location?.href?.includes('doNotRedirect');

export const delayedRedirect = (url: string, delayTimeInMillis: number): void => {
    if (url && shouldRedirect()) {
        window.setTimeout(() => replaceUrl(url), delayTimeInMillis ? delayTimeInMillis : 0);
    }
};
